import { SoccerIncidentId } from '@collector/sportsapi-client-legacy'

import { PitchTeamIncidentsConfig } from '../../configuration'

export const pitchTeamIncidentsConfig: PitchTeamIncidentsConfig<SoccerIncidentId> =
  {
    [SoccerIncidentId.Goal]: {
      tooltipText: 'Confirm or cancel previous Goal',
    },
    [SoccerIncidentId.Penalty]: {
      tooltipText: 'Confirm or cancel previous Penalty',
    },
  }
